export default "__VITE_ASSET__FfYbT1vR__"